import { createReducer, on } from "@ngrx/store";
import { initialResetMFAState, ResetMFAState } from "./reset-mfa.state";
import { ClearResetMFAState, HasMFA, HasMFAError, HasMFASuccess, ResetMFA, ResetMFAError, ResetMFASuccess } from "./reset-mfa.actions";

export const ResetMFAReducers = createReducer(
  initialResetMFAState,
  on(ResetMFA, (state): ResetMFAState => {
    return {
      ...state,
      resetMfaLoader: true,
      resetMfaResult: null,
      resetMfaError: null
    };
  }),
  on(ResetMFASuccess, (state, action): ResetMFAState => {
    return {
      ...state,
      resetMfaLoader: false,
      resetMfaResult: action.result
    };
  }),
  on(ResetMFAError, (state, action): ResetMFAState => {
    return {
      ...state,
      resetMfaLoader: false,
      resetMfaError: action.error
    };
  }),
  on(HasMFA, (state): ResetMFAState => {
    return {
      ...state,
      hasMfa: false
    };
  }),
  on(HasMFASuccess, (state, action): ResetMFAState => {
    return {
      ...state,
      hasMfa: action.result
    };
  }),
  on(HasMFAError, (state): ResetMFAState => {
    return {
      ...state,
      hasMfa: false
    };
  }),
  on(ClearResetMFAState, (_): ResetMFAState => {
    return initialResetMFAState;
  }),
)